"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamDTOSchema = void 0;
const ETeam_1 = require("./ETeam");
const PlayerDTO_1 = require("./PlayerDTO");
const zod_1 = require("zod");
const ProjectDTO_1 = require("./ProjectDTO");
const SlotDTO_1 = require("./SlotDTO");
const CardDTO_1 = require("./CardDTO");
const ECardHandler_1 = require("./ECardHandler");
const ETurn_1 = require("./ETurn");
const ECardStateGame_1 = require("./ECardStateGame");
const DicesTurnDTO_1 = require("./DicesTurnDTO");
const MoneyDTO_1 = require("./MoneyDTO");
const PleasurePointsDTO_1 = require("./PleasurePointsDTO");
const ChargeDTO_1 = require("./ChargeDTO");
const SavingsDTO_1 = require("./SavingsDTO");
const IncomeDTO_1 = require("./IncomeDTO");
const DiceEventDTO_1 = require("./DiceEventDTO");
const TeamDTOSchema = zod_1.z.object({
    teamColor: zod_1.z.nativeEnum(ETeam_1.ETeam),
    players: zod_1.z.array(PlayerDTO_1.PlayerDTOSchema),
    teamActive: zod_1.z.boolean(),
    money: MoneyDTO_1.MoneySchema.optional(),
    pleasurePoints: PleasurePointsDTO_1.PleasurePointsSchema.optional(),
    project: ProjectDTO_1.ProjectDTOSchema.optional(),
    projectsProposed: zod_1.z.array(ProjectDTO_1.ProjectDTOSchema),
    savings: SavingsDTO_1.SavingsSchema.optional(),
    incomes: zod_1.z.array(IncomeDTO_1.IncomeSchema),
    charges: zod_1.z.array(ChargeDTO_1.ChargeSchema),
    hasBailifPenalty: zod_1.z.boolean(),
    slotTeam: SlotDTO_1.SlotSchema,
    cards: zod_1.z.array(CardDTO_1.CardSchema),
    cardSelected: CardDTO_1.CardSchema.optional(),
    cardProposed: zod_1.z.array(CardDTO_1.CardSchema),
    cardHandlerEnum: zod_1.z.nativeEnum(ECardHandler_1.ECardHandler),
    turnState: zod_1.z.nativeEnum(ETurn_1.ETurn),
    cardState: zod_1.z.nativeEnum(ECardStateGame_1.ECardStateGame),
    dicesTurn: DicesTurnDTO_1.DicesTurnSchema,
    dicesEvent: DiceEventDTO_1.DiceEventSchema,
});
exports.TeamDTOSchema = TeamDTOSchema;
